<template>
  <EmailContact />
</template>

<script setup lang="ts">
definePageMeta({
  layout: 'center',
  middleware: [
    'naver-ads',
    'kakao-pixel'
  ]
})

const { ogUrl, ogTitle, keyword } = useSeo()

useSeoMeta({
  title: '이메일 문의',
  description: '유심사의 eSIM, USIM 서비스가 궁금하세요? 궁금한 모든 것들을 이메일로 문의주세요. 빠르게 답변해 드릴게요.',
  ogType: 'website',
  ogUrl: () => ogUrl('board/email'),
  ogTitle: () => ogTitle('이메일 문의'),
  ogDescription: '유심사의 eSIM, USIM 서비스가 궁금하세요? 궁금한 모든 것들을 이메일로 문의주세요. 빠르게 답변해 드릴게요.',
  twitterCard: 'summary',
  twitterTitle: () => ogTitle('이메일 문의'),
  twitterDescription: '유심사의 eSIM, USIM 서비스가 궁금하세요? 궁금한 모든 것들을 이메일로 문의주세요. 빠르게 답변해 드릴게요.',
  keywords: keyword('이메일 문의, eSIM이메일 문의, 이심이메일 문의, USIM이메일 문의, 유심이메일 문의')
})


</script>
